module.exports = __webpack_public_path__ + "img/storeroom.d4350a80.png";